import * as actions from './actions';
import reducers from './reducer';

export const Artist = { actions, reducers };
export { ArtistState } from './reducer';
